import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import Transformer from './transformer';
import { AuthContext, AppContext } from '@CONTEXTS';

const { SubMenu } = Menu;

const Recursion = (ds) => {
  return ds.map((menu) => {
    if (menu.children && menu.children.length > 0) {
      return (
        <SubMenu
          key={menu.key}
          title={menu.name}
          icon={menu.icon}
        >
          {Recursion(menu.children)}
        </SubMenu>
      );
    } else {
      return (
        <Menu.Item key={menu.key} icon={menu.icon} title={menu.name}>
          <Link to={menu.link}>{menu.name}</Link>
        </Menu.Item>
      );
    }
  });
};

const HJMenu = () => {
  const { info } = useContext(AuthContext);
  const { path } = useContext(AppContext);
  const [selectedKey, setSelectedKey] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  const menu = useMemo(
    () => Transformer.fetch(info.menu, info?.dashboardDisabled),
    [info.menu, info?.dashboardDisabled]
  );

  useEffect(() => {
    const activePaths = Transformer.getActivePaths(
      { children: menu },
      { link: path }
    );
    setSelectedKey(activePaths.selectedKey);
    setOpenKeys(activePaths.openKeys);
  }, [menu, path]);

  //if (selectedKey.length === 0) return null;

  return (
    <Menu
      mode="inline"
      theme="dark"
      defaultOpenKeys={openKeys}
      selectedKeys={selectedKey}
      inlineIndent={16}
    >
      {Recursion(menu)}
    </Menu>
  );
};

export default HJMenu;
